<template>
  <div>
    <!-- 右侧悬浮按钮 -->
    <div 
    v-show="showApp"
      class="home_right" 
      @mouseenter.prevent="showPanel = true" 
      @mouseleave.prevent="showPanel = false"
    >
      <img src="@/assets/image/home/home_right.png" width="62" height="316" alt="联系我们">
    </div>
    <div class="home1" >
      <el-popover placement="left" trigger="hover" popper-class="el-set">
        <img class="gzh1" src="@/assets/image/icon_gzh.png" alt="">
        <div class="gzh" slot="reference">
          <img src="@/assets/image/icon_clothes.png" alt="">
        </div>
      </el-popover>
      
    </div>
    <!-- 滑出面板 -->
    <transition name="slide-fade">
      <div 
        class="showAPP" 
        v-if="showPanel"
        @mouseenter.prevent="showPanel = true" 
        @mouseleave.prevent="showPanel = false"
      >
        <!-- 两个二维码项目 -->
        <div class="item">
          <img src="@/assets/image/home/android.png" width="200" height="200" alt="安卓版下载">
          <p class="t-m-t-10 flex-coloum" style="align-items: center;justify-content: center;">
            <span>扫描二维码</span>
            <span>下载全民作家官方app（安卓端）</span>
          </p>
        </div>
        <!-- <div class="item">
          <img src="@/assets/image/home/ios.png" width="200" height="200" alt="苹果版下载">
          <p class="t-m-t-10">苹果版   敬请期待</p>
        </div> -->
        
        <!-- 箭头 -->
        <div class="arrow"></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FloatContactPanel',
  data() {
    return {
      showPanel: false
    }
  },
  props:{
    showApp:{
      type:Boolean,
      default:true
    },
  }
}
</script>

<style lang="scss" scoped>
.home_right {
  position: fixed;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  z-index: 1001;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-50%);
  }
}

.showAPP {
  position: fixed;
  top: 50%;
  right: 80px; /* 根据home_right的宽度调整 */
  transform: translateY(-50%);
  padding: 20px;
  // display: grid;
  // grid-template-columns: repeat(2, 1fr);
  // gap: 20px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  
  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      margin: 10px 0 0 0;
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }
    .jqqd{
        height: 200px;
        width: 200px;
        background-color: rgba(0,0,0,0.3);
        font-size: 35px;
        display: flex;
        align-items: center;
        justify-items: center;
    }
  }
  
  /* 箭头样式 */
  .arrow {
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid #fff;
  }
}

/* 过渡动画 */
.slide-fade-enter-active {
  transition: all 0.1s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.1s ease-in;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translate(20px, -50%);
}

.home1 {
  position: fixed;
  right: 8px;
  bottom: 5%;
  cursor: pointer;
}

.home1 img {
  width: 71px;
}
.gzh1{
  width: 225px;
  height: 300px;
}
</style>